import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNumber, IsString } from 'class-validator';
import { DealProcessingStatus } from './const';

export class ProcessingViewModel {
  @Expose()
  @ApiProperty({ description: 'Unique deal.processing ID', example: 1001 })
  @IsString()
  id: string;

  @Expose()
  @ApiProperty()
  @IsNumber()
  status: DealProcessingStatus;

  @Expose()
  @ApiProperty({ description: 'Unique deal ID', example: '01a04fba-cb29-76b5-9d25-fb623c8bddb6' })
  dealId: string;
}
